import webBiLogger from '@wix/web-bi-logger';
import { BI_EVENTS, biEventsMap, biConstants } from './biEvents';
import wix from '../services/wix';
import { ChatroomDisplayData } from '../components/Widgets/SocialChat/SocialChat';

let logger;

export const initLogger = ({
  instanceId: app_instance_id,
  biToken: bi_token,
  visitorId: visitor_id,
  viewMode: mode,
  isSocial: is_social,
  isBusiness: is_business,
}: any) => {
  logger = webBiLogger
    .factory({ endpoint: biConstants.BI_END_POINT })
    .setEvents(biEventsMap)
    .setDefaults({
      src: biConstants.BI_ENGAGE_SRC,
      app_instance_id,
      bi_token,
      visitor_id,
      is_social,
      is_business,
      mode,
    })
    .logger();
};

export const sendMessageEvent = ({ chatRoomType = '', host }) => {
  const mode = wix.getViewMode();
  return logger.log(BI_EVENTS.SEND_MESSAGE, {
    mode,
    chatRoomType,
    widget_sub_type: host,
  });
};

export const expandChatEvent = ({
  direction,
  referrer,
  chatRoomType = '',
  host,
}) => {
  const mode = wix.getViewMode();
  return logger.log(BI_EVENTS.EXPAND_CHAT, {
    mode,
    widget_sub_type: host,
    direction,
    triggerBy: referrer,
    chatRoomType,
  });
};

export const messageReceivedEvent = shard_id => {
  const mode = wix.getViewMode();
  return logger.log(BI_EVENTS.REALTIME_ACTIVITY, { mode, shard_id });
};

export const sendDebug = ({ tag, description }) => {
  const mode = wix.getViewMode();
  return logger.log(BI_EVENTS.DEBUG, { tagId: tag, description, mode });
};

export const attachmentClickEvent = () => {
  const mode = wix.getViewMode();
  return logger.log(BI_EVENTS.ADD_ATTACHMENT_CLICK, { mode });
};

export const imageClickEvent = () => {
  const mode = wix.getViewMode();
  return logger.log(BI_EVENTS.IMAGE_CLICK, { mode });
};

export const chatDisplayedEvent = (deviceType, layoutName) => {
  const mode = wix.getViewMode();
  const loadTime = Date.now() - window.startLoadTime;
  const isFullRender = /fullRender/.test(window.location.href);
  return logger.log(BI_EVENTS.CHAT_DISPLAYED, {
    platform: deviceType === 'mobile' ? 'QAB' : 'desktop',
    load_time: loadTime,
    is_full_render: isFullRender,
    layoutName,
    mode,
  });
};

export const callToActionClickEvent = url => {
  const mode = wix.getViewMode();
  return logger.log(BI_EVENTS.CALL_TO_ACTION_CLICK, { url, mode });
};

export const lcfSubmission = () => {
  const mode = wix.getViewMode();
  return logger.log(BI_EVENTS.LCF_SUBMISSION, { mode });
};

export const copyCouponCode = () => {
  const mode = wix.getViewMode();
  return logger.log(BI_EVENTS.COPY_COUPON_CODE, { mode });
};

export const socialNewConversion = entry_point => {
  const mode = wix.getViewMode();
  return logger.log(BI_EVENTS.SOCIAL_CHAT_NEW_CONVERSION, {
    entry_point,
    mode,
  });
};

export const socialSearchResults = result_number => {
  const mode = wix.getViewMode();
  return logger.log(BI_EVENTS.SOCIAL_CHAT_SEARCH_MEMBER, {
    result_number,
    mode,
  });
};

export const groupChatCreateStart = () => {
  return logger.log(BI_EVENTS.GROUP_CHAT_CREATE_START, {
    referralInfo: 'new chat',
    chatRoomType: 'group chat',
    origin: 'web',
  });
};

export const groupChatCreateMemberPickerFilter = (membersDisplayed: number) => {
  return logger.log(BI_EVENTS.GROUP_CHAT_CREATE_MEMBER_PICKER_FILTER, {
    origin: 'web',
    referralInfo: 'new group-members picker',
    membersDisplayed,
  });
};

export const groupChatCreateMemberPickerNext = (
  member_of_members_selected: number,
) => {
  return logger.log(BI_EVENTS.GROUP_CHAT_CREATE_MEMBER_PICKER_NEXT, {
    origin: 'web',
    referralInfo: 'new group-members picker',
    member_of_members_selected,
  });
};

export const groupChatCreateMemberPickerBack = () => {
  return logger.log(BI_EVENTS.GROUP_CHAT_CREATE_MEMBER_PICKER_BACK, {
    origin: 'web',
    referralInfo: 'new group-members picker',
  });
};

export const groupChatCreateMemberPickerSelect = (
  memberId: string,
  numberOfContacts: number,
) => {
  // TODO:
  return logger.log(
    BI_EVENTS.GROUP_CHAT_CREATE_MEMBER_PICKER_CHECKBOX_CLICKED,
    {
      origin: 'web',
      referralInfo: 'new group-members picker',
      chatRoomType: 'group chat',
      memberId,
      numberOfContacts,
    },
  );
};

export const groupChatCreateMemberPickerRemove = (memberId: string) => {
  return logger.log(BI_EVENTS.GROUP_CHAT_CREATE_MEMBER_PICKER_REMOVE, {
    origin: 'web',
    referralInfo: 'new group-members picker',
    memberId,
  });
};

export const groupChatCreateRoomInfoCreate = (
  number_of_members_selected: number,
) => {
  return logger.log(BI_EVENTS.GROUP_CHAT_CREATE_ROOM_INFO_CREATE, {
    origin: 'web',
    referralInfo: 'new group-info',
    number_of_members_selected,
  });
};

export const groupChatCreateRoomInfoBack = () => {
  return logger.log(BI_EVENTS.GROUP_CHAT_CREATE_ROOM_INFO_BACK, {
    origin: 'web',
    referralInfo: 'new group-info',
  });
};

export const groupChatCreateRoomInfoUploadAvatar = () => {
  return logger.log(BI_EVENTS.GROUP_CHAT_CREATE_ROOM_INFO_UPLOAD_AVATAR, {
    origin: 'web',
    referralInfo: 'new group-info',
  });
};

export const forGroupChat = (
  currentChatroom: ChatroomDisplayData,
  memberId: string,
): GroupChatBi => {
  const role = currentChatroom.createBy === memberId ? 'owner' : 'member';
  const chatroomId = currentChatroom.id;

  return new GroupChatBi('web', role, chatroomId, memberId);
};

export class GroupChatBi {
  chatroomParam: {
    origin: string;
    role: string;
    chatroomId: string;
    memberId: string;
    chatRoomType: string;
  };

  constructor(
    origin: string,
    role: string,
    chatroomId: string,
    memberId: string,
  ) {
    this.chatroomParam = {
      origin,
      role,
      chatroomId,
      memberId,
      chatRoomType: 'group chat',
    };
  }

  logger = (biEvents: { evid: number }, loggerParam: any) => {
    return logger.log(biEvents, {
      ...this.chatroomParam,
      ...loggerParam,
    });
  };

  groupChatLeaveConfirm = () => {
    return this.logger(BI_EVENTS.GROUP_CHAT_LEAVE_CONFIRM, {
      referralInfo: 'group chat leave room',
    });
  };

  groupChatMenuSelected = (button: string) => {
    return this.logger(BI_EVENTS.GROUP_CHAT_MENU_SELECTED, {
      referralInfo: 'group chat room options',
      button,
    });
  };

  groupChatMenuClicked = () => {
    return this.logger(BI_EVENTS.GROUP_CHAT_MENU_CLICKED, {
      referralInfo: 'group chat room',
    });
  };

  groupChatMembersClickAdd = () => {
    return this.logger(BI_EVENTS.GROUP_CHAT_MEMBERS_CLICK_ADD, {
      referralInfo: 'group chat info',
    });
  };

  groupChatMembersClickRemove = () => {
    return this.logger(BI_EVENTS.GROUP_CHAT_MEMBERS_CLICK_REMOVE, {
      referralInfo: 'group chat info',
    });
  };

  groupChatMembersConfirmRemove = () => {
    return this.logger(BI_EVENTS.GROUP_CHAT_MEMBERS_CONFIRM_REMOVE, {
      referralInfo: 'group chat info',
    });
  };

  groupChatMembersPickerCheckboxClicked = () => {
    return this.logger(BI_EVENTS.GROUP_CHAT_MEMBERS_PICKER_CHECKBOX_CLICKED, {
      referralInfo: 'group chat info',
    });
  };

  groupChatMembersPickerRemove = () => {
    return this.logger(BI_EVENTS.GROUP_CHAT_MEMBERS_PICKER_REMOVE, {
      referralInfo: 'group chat info',
    });
  };

  groupChatMembersConfirmAdd = () => {
    return this.logger(BI_EVENTS.GROUP_CHAT_MEMBERS_CONFIRM_ADD, {
      referralInfo: 'chat group add member',
    });
  };

  groupChatInfoConfirm = () => {
    return this.logger(BI_EVENTS.GROUP_CHAT_INFO_CONFIRM, {
      referralInfo: 'edit group details',
    });
  };

  groupChatInfoUploadAvatar = () => {
    return this.logger(BI_EVENTS.GROUP_CHAT_INFO_UPLOAD_AVATAR, {
      referralInfo: 'group chat info',
    });
  };
}
